import { z } from "zod";

export const ContactMessageSchema = z.object({
  message: z.object({
    name: z.string().min(2).max(255).nonempty(),
    email: z.string().email().nonempty(),
    content: z.string().min(10).max(5000).nonempty(),
    phone: z.string().min(10).max(20).nonempty(),
  }),
});
